import React, { useRef, useState } from "react";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import swal from "sweetalert";
import Drawer from "@material-ui/core/Drawer";
import Loader from "../../UI Component/Loader/Loader";
import samplecsv from "../../../assets/sample_patient.csv";
import errorIcon from "../../../assets/errorIcon.svg";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";
import { getSignedUrl } from "../../../Util/API Calls/SignedAPIUrl";

const UploadPatients = (props) => {
  const [error, seterror] = useState("");
  const [loading, setloading] = useState(false);
  const { open, onClose, refetchPatients, openSuccesModal } = props;

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  const handlDrawerClose = () => {
    seterror("");
    onClose();
  };
  let inputRef = useRef();
  const wrongOrder =
    "File should have all columns with headers and in the same order.";
  const handleChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = async () => {
        try {
          const lastDot = file.name.lastIndexOf(".");
          const fileObject = {
            value: reader.result,
            name: file.name,
            size: (file.size / 1024 / 1024).toFixed(2),
            type: file.name.substring(lastDot + 1),
            fileDate: file,
          };
          var allowedExtensions = /(\.csv)$/i;
          if (allowedExtensions.exec(fileObject.name)) {
            const signedUrl = await getSignedUrl(
              {
                file_size: file.size,
                doc_title: file.name,
                use_case: "upload_offline_patients",
              },
              file
            );

            if (signedUrl) {
              const response = await afterLoginApiAxios({
                method: "post",
                url: "/doctor/upload-patient-csv",
                headers: {
                  Authorization: localStorage.getItem("id_token"),
                },
                data: {
                  "authorizer-principal-id": {
                    user_type: "1",
                  },
                  doctor_id: userId,
                  upload_document: {
                    name: file.name,
                    value: fileObject.value,
                    size: fileObject.size,
                  },
                },
              });
              C2CConsole.log(response);
              if (response) setloading(false);
              if (response.data.statusCode == "200") {
                openSuccesModal();
                // update parent
                refetchPatients();
              } else {
                seterror(response.data.message);
              }
            }
          } else {
            setloading(false);
            seterror("File Type should be .csv");
          }
        } catch (error) {
          C2CConsole.log("error", error);
        }
      };
    }
    event.target.value = "";
  };
  return (
    <>
      {loading ? <Loader /> : null}
      <Drawer anchor={"right"} open={open} onClose={() => handlDrawerClose()}>
        <div className="py-4 previous-patients-prescription-edit-drawer px-4 px-md-2">
          <div className=" container">
            <span style={{ fontSize: "25px" }}>Upload Patient</span>
            <span
              className="float-right cursor-pointer"
              onClick={() => handlDrawerClose()}
              style={{ fontSize: "1rem" }}
            >
              Close <i className="fa fa-times" aria-hidden="true"></i>
            </span>
          </div>
          <div className="container mt-3">
            <p>
              <b>
                Select a{" "}
                <a href={samplecsv} style={{ textDecoration: "none" }} download>
                  {" "}
                  <span style={{ color: "#F969A4" }}>.csv</span>
                </a>{" "}
                file to add a new patient. You can download a sample file which
                contains the required fields.
              </b>
            </p>
            <div className="mt-3">
              <input
                type="file"
                accept=".csv"
                style={{ display: "none" }}
                ref={(ref) => (inputRef = ref)}
                onChange={handleChange}
              />
              <button
                className="btn  border rounded "
                style={{ backgroundColor: "#17BAE0", color: "white" }}
                onClick={() => inputRef.click()}
              >
                Choose File
              </button>
              <a href={samplecsv} download>
                <span
                  className="btn border-0"
                  style={{ backgroundColor: "white", color: "#17BAE0" }}
                >
                  Download Sample
                </span>
              </a>
            </div>
          </div>
          {error ? (
            <>
              <div className="container mt-3">
                <img
                  src={errorIcon}
                  style={{ width: "30px", height: "30px" }}
                />{" "}
                <span className="ml-1">
                  <b>Unable to upload file.</b>
                </span>
              </div>
              <div className="container mt-3 uploadPatient-notice">
                <div className="p-2" style={{ backgroundColor: "#F5F6F7" }}>
                  <p>Please ensure the following for the file uploaded</p>
                  {error != wrongOrder ? (
                    <>
                      <p style={{ color: "#DA1346" }}>{error}</p>
                    </>
                  ) : (
                    <>
                      <p style={{ color: "#DA1346" }}>{error}</p>
                      <ol>
                        <li>
                          1.<b>Patient Phone Number*</b>
                        </li>
                        <li>
                          2.<b>Patient Name*</b>
                        </li>
                        <li>
                          3.<b>Patient Email</b>
                        </li>
                        <li>
                          4.<b>Patient DOB*</b>
                        </li>
                        <li>
                          5.<b>Patient Sex*</b>
                        </li>
                        <li>6.Patient Purpose of the appointment</li>
                        <li>7.Patient Address</li>
                        <li>8.Patient Pin Code</li>
                      </ol>
                    </>
                  )}
                </div>
              </div>
            </>
          ) : (
            <div className="container mt-3 uploadPatient-notice  ">
              <ol className=" p-2" style={{ backgroundColor: "#F5F6F7" }}>
                <li>Please ensure the following for the file uploaded </li>
                <li>
                  1.File Type is <b>.csv</b>
                </li>
                <li>
                  2.File should have following columns with following headers
                  and in the same order:
                  <ol className="uploadPatient-inner-list">
                    <li>a.Patient Phone Number*</li>
                    <li>b.Patient Name*</li>
                    <li className="font-weight-bold">c.Patient Email</li>
                    <li>d.Patient DOB</li>
                    <li>e.Patient Sex*</li>
                    <li>f.Patient Purpose of the appointment</li>
                    <li>g.Patient Address</li>
                    <li>h.Patient Pin Code</li>
                  </ol>
                </li>
                <li>
                  3.The field highlighted with <b>* are mandatory.</b>{" "}
                </li>
                <li>
                  4.Apart from header there should be at least one row of data.
                </li>
                <li>
                  5.For a particular records, data needs to be present{" "}
                  <b>in all mandatory column.</b>
                </li>
                <li>
                  6.The <b>first row of the csv</b> is a header row. The{" "}
                  <b>second row of the csv</b> is sample data row and has to be
                  removed before uploading the csv file.
                </li>
              </ol>
            </div>
          )}
        </div>
      </Drawer>
    </>
  );
};
export default UploadPatients;
